import React from "react";
import { useTranslation } from "react-i18next";
import { FaDiamond } from "react-icons/fa6";

// Components
import Divider from "../../components/divider";
import Progress from "../../components/progress";

// Styles
import styles from "./level.module.css";

const Level = ({ level, currentExp, totalExp }) => {
  // Hooks
  const { t } = useTranslation();

  return (
    <div className={`${styles.container} border-gray-200 rounded-2xl`}>
      <div className={styles.header}>
        <div className='flex flex-row gap-2 items-center'>
          <svg width="0" height="0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="diamond-gradient" x1="12.0005" y1="0.0078125" x2="12.0005" y2="20.0044" gradientUnits="userSpaceOnUse">
                <stop stopColor="#53B1FD" />
                <stop offset="1" stopColor="#2E90FA" />
              </linearGradient>
            </defs>
          </svg>
          <FaDiamond style={{ fill: "url(#diamond-gradient)" }} />

          <p className='text-md text-black dark:text-white'>
            {t('progress.level', { level })}
          </p>
        </div>

        <p className='text-md text-gray-500 dark:text-gray-400'>
          <span className='text-blue-500 me-1'>
            {currentExp}
          </span>

          / {totalExp} XP
        </p>
      </div>

      <Divider className='dark:border-gray-200 border-gray-700 my-4' />

      <Progress progress={(currentExp / totalExp) * 100} />
    </div>
  )
}

export default Level;
